import {FormatMessageFunction} from '@fo/shared-types';

export enum IdentityForm {
  CREATE_ACCOUNT = 'createAccount',
  CONFIRM_EMAIL_ADDRESS = 'confirmEmailAddress',
  FORGOT_PASSWORD = 'forgotPassword',
  LOGIN = 'login',
  RESET_PASSWORD = 'resetPassword',
}

export enum IdentityErrors {
  EXPIRED_CODE = 'ExpiredCodeException',
  INVALID_PARAMETER = 'InvalidParameterException',
  LIMIT_EXCEEDED = 'LimitExceededException',
  NOT_AUTHORIZED = 'NotAuthorizedException',
  SERIALIZATION = 'SerializationException',
  USERNAME_EXISTS = 'UsernameExistsException',
  USER_NOT_FOUND = 'UserNotFoundException',
  CODE_MISMATCH = 'CodeMismatchException',
}

const identityError = (
  code: string | IdentityErrors,
  formatMessage: FormatMessageFunction,
  form: IdentityForm
): string => {
  switch (form) {
    case IdentityForm.LOGIN:
      return formatMessage({id: 'identity.errors.loginError'});

    case IdentityForm.RESET_PASSWORD:
      switch (code) {
        case IdentityErrors.USER_NOT_FOUND:
          return formatMessage({id: 'identity.errors.userNotFoundException'});
        case IdentityErrors.NOT_AUTHORIZED:
          return formatMessage({id: 'identity.errors.notAuthorizedException'});
        case IdentityErrors.CODE_MISMATCH:
          return formatMessage({id: 'identity.errors.codeMismatchException'});
        case IdentityErrors.EXPIRED_CODE:
          return formatMessage({id: 'identity.errors.expiredCodeException'});
        case IdentityErrors.LIMIT_EXCEEDED:
        // fallthrough
        default:
          return formatMessage({id: 'identity.errors.default'});
      }

    case IdentityForm.FORGOT_PASSWORD:
      switch (code) {
        case IdentityErrors.INVALID_PARAMETER:
          return formatMessage({id: 'identity.errors.invalidParameterException'});
        case IdentityErrors.LIMIT_EXCEEDED:
          return formatMessage({id: 'identity.errors.limitExceededException'});
        default:
          return formatMessage({id: 'identity.errors.forgotPasswordError'});
      }

    case IdentityForm.CONFIRM_EMAIL_ADDRESS:
      switch (code) {
        case IdentityErrors.EXPIRED_CODE:
          return formatMessage({id: 'identity.errors.expiredCodeException'});
        case IdentityErrors.NOT_AUTHORIZED:
          return formatMessage({id: 'identity.errors.notAuthorizedException'});
        case IdentityErrors.USER_NOT_FOUND:
          return formatMessage({id: 'identity.errors.userNotFoundException'});
        default:
          return formatMessage({id: 'identity.errors.default'});
      }

    case IdentityForm.CREATE_ACCOUNT:
      switch (code) {
        case IdentityErrors.SERIALIZATION:
          return formatMessage({id: 'identity.errors.serializationException'});
        case IdentityErrors.USERNAME_EXISTS:
          return formatMessage({id: 'identity.errors.usernameExistsException'});
        case IdentityErrors.INVALID_PARAMETER:
          return formatMessage({id: 'identity.errors.invalidParameterException'});
        default:
          return formatMessage({id: 'identity.errors.default'});
      }

    default:
      return formatMessage({id: 'identity.errors.default'});
  }
};

export default identityError;
